import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { AppRoutes } from "@/routes/config";
import { verifyToken } from "@/utils/token";
import Cookies from "js-cookie";
import { FC, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const withPublicAuth: <CP extends {}>(WrappedComponent: FC<CP>) => FC<CP> = (WrappedComponent) => (props) => {
  const { pathname } = useLocation();
  const [isVerified, setIsVerified] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = Cookies.get("learner-token");
    const userId = Cookies.get("learner-user-id");
    const accountId = Cookies.get("learner-account-id");
    const hasSession = !!token && !!userId && !!accountId;
    const isAuthenticated = hasSession && verifyToken(token);

    // Redirect authenticated users away from public auth routes to home
    if (isAuthenticated) {
      navigate(AppRoutes.home);
      return;
    }

    setIsVerified(true);
  }, [pathname, navigate]);

  if (!isVerified) return <LoadingScreen />;

  return <WrappedComponent {...props} />;
};
